export default "__VITE_ASSET__CWDtCOcP__"